/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
////////////////// AKA: Two Columns Swiper Banner in inititive/temp4 template //////////////////
import { RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { A11y, Pagination } from "swiper";

import Image from "next/image";
import IsRtl from "components/Shared/isRtl";
import { DGACarouselArrow } from "components/Shared/dga-carousel-arrow/DGACarouselArrow";

type SwiperCardWithBannerDescriptionProps = {
  SectionId: string;
  fields: SwiperCardWithBannerDescriptionfields;
  TitleFontSize: string;
  DescriptionFontSize: string;
  PointFontSize: string;
  showAnimation: boolean;
  locale: any;
  sectionIx: number;
};

export default function SwiperCardWithBannerDescription(
  props: SwiperCardWithBannerDescriptionProps
) {
  const [swiper, setSwiper] = useState<any>();
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);
  const handleSwiperUpdate = (swiper: any) => {
    setSwiper(swiper);
    // check if at end or at beginneg
    swiper.on("slideChange", () => {
      if (swiper.isEnd) {
        setIsEnd(true);
      } else {
        setIsEnd(false);
      }
      if (swiper.isBeginning) {
        setIsBeginning(true);
      } else {
        setIsBeginning(false);
      }
    });
  };

  const componentId = `${props?.SectionId}-${props?.sectionIx}`.trim().replace(/ /g, "-");
  useEffect(() => {
    if (swiper) {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);

      // Optional: attach listener once only
      swiper.on("slideChange", () => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
      });
    }
  }, [swiper]);
  return (
    <div id={props?.SectionId} className="py-10  bg-neutral-100 w-full relative ">
      <div className=" relative z-10 ">
        {(props?.fields?.Title?.value || props?.fields?.Description?.value) && (
          <div className="flex responsive flex-col gap-5">
            {props?.fields?.Title?.value && (
              <h2
                className="text-[30px] font-bold animate-top-dga"
                id={"template-carousel-title-" + props?.SectionId}
              >
                {props?.fields?.Title?.value}
              </h2>
            )}
            {props?.fields?.Description?.value && (
              <div id={"template-carousel-desc-" + props?.SectionId} className="animate-top-dga overflow-hidden">
                <RichText field={props?.fields?.Description} />
              </div>
            )}
          </div>
        )}

        {props?.fields?.Items?.length > 0 && (
          <div
            className={`${swiper ? "opacity-100" : "opacity-0"} transition-opacity md:responsive ${
              IsRtl() ? "mr-[5%] " : "ml-[5%] "
            } duration-500 pt-10`}
          >
            <Swiper
              onInit={(ev) => {
                setSwiper(ev as any);
                if (ev.isEnd) {
                  setIsEnd(true);
                } else {
                  setIsEnd(false);
                }
                if (ev.isBeginning) {
                  setIsBeginning(true);
                } else {
                  setIsBeginning(false);
                }
              }}
              onSwiper={(e) => {
                handleSwiperUpdate(e);
                // check end and beginner
              }}
              slidesPerView={1.2}
              spaceBetween={16}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
              }}
              pagination={{ clickable: true, el: `#${componentId}` }}
              freeMode={true}
              modules={[Pagination, A11y]}
              a11y={{
                enabled: true,
                paginationBulletMessage: "Go to slide {{index}}",
              }}
              dir={IsRtl() ? "rtl" : "ltr"}
              className="mySwiper !p-[1px]"
            >
              {props?.fields?.Items?.length > 0 &&
                props?.fields?.Items?.map((point: SwiperItem, index: number) => {
                  return (
                    <SwiperSlide className="w-full !h-auto overflow-hidden" key={index}>
                      <div className=" animate-top-dga overflow-hidden w-full rounded-2xl h-full border border-neutral-300 p-4 flex bg-white flex-col gap-5 items-center">
                        {point?.fields?.Icon?.value?.src && (
                          <div className="h-[48px] bg-neutral-100 rounded-full relative w-[48px] mx-auto">
                            <Image
                              unoptimized
                              src={point?.fields?.Icon?.value?.src}
                              alt={(point?.fields?.Icon?.value?.alt ?? "").trim() || (point?.fields?.Title?.value ?? "").trim() || "Banner icon"}
                              layout="fill"
                              objectFit="contain"
                            />
                          </div>
                        )}
                        {point?.fields?.Title?.value && (
                          <p className="text-lg font-bold">{point?.fields?.Title?.value}</p>
                        )}
                        {point?.fields?.Description?.value && (
                          <RichText
                            id={"section-point-" + props?.SectionId + "-" + index}
                            className=""
                            field={point?.fields?.Description}
                          />
                        )}
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        )}
      </div>
      <div id={componentId} className="md:hidden custom_swiper !mt-8 mx-auto !justify-center" />
      {props?.fields?.Items?.length > 2 && (
        <div className="responsive mt-8 hidden md:block">
          <div
            className={`
        ${swiper ? "opacity-100" : "opacity-0"}
        w-fit
        ${IsRtl() ? "mr-auto" : "ml-auto"}
        flex-row gap-4
        hidden
        ${props?.fields?.Items?.length > 2 ? "md:flex" : "md:hidden"}
      `}
          >
            <DGACarouselArrow
              direction={IsRtl() ? "right" : "left"}
              onClick={() => {
                swiper?.slidePrev();
                handleSwiperUpdate(swiper);
              }}
              size={"large"}
              disabled={isBeginning}
              style={"primary"}
            />
            <DGACarouselArrow
              direction={IsRtl() ? "left" : "right"}
              onClick={() => {
                swiper?.slideNext();
                handleSwiperUpdate(swiper);
              }}
              size={"large"}
              disabled={isEnd}
              style={"primary"}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export type SwiperCardWithBannerDescriptionCo = {
  displayName: "SwiperCardWithBannerDescription";
  fields: SwiperCardWithBannerDescriptionfields;
};

type SwiperCardWithBannerDescriptionfields = {
  Title: {
    value: string;
  };
  Description: {
    value: string;
  };
  TitleColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  TitleFont: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  DescriptionColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  DescriptionFont: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  BoxColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  BoxNumberColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  ItemTextColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  ItemTextFont: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  Items: SwiperItem[];
  BackgroundColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  BackgroundImage: {
    value: {
      src: string;
      alt: string;
      width: string;
      height: string;
    };
  };
  Buttons: [
    {
      id: string;
      fields: {
        BtnText: {
          value: string;
        };
        BtnUrl: {
          value: {
            href: string;
            linktype: string;
            url: string;
            anchor: string;
            target: string;
          };
        };
        BtnBoxColor: {
          fields: {
            Title: {
              value: string;
            };
          };
        };
        BtnTextColor: {
          fields: {
            Title: {
              value: string;
            };
          };
        };
        BtnFont: {
          fields: {
            Title: {
              value: string;
            };
          };
        };
        File: {
          value: {
            src: string;
            name: string;
            title: string;
            extension: string;
            mimeType: string;
            size: string;
          };
        };
        isFile: {
          value: boolean;
        };
      };
    }
  ];
  Pattern: {
    value: {
      src: string;
      alt: string;
      width: string;
      height: string;
    };
  };
  ArrowColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  BannerDescription: {
    value: string;
  };
  isScrollAllowed: {
    value: boolean;
  };
  ItemType: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  ScrollToText: {
    value: string;
  };
  SectionTemplate: {
    displayName: string;
    fields: {
      Title: {
        value: string;
      };
    };
  };
};

type SwiperItem = {
  id: string;
  fields: {
    Icon: {
      value: {
        src: string;
        alt: string;
        width: string;
        height: string;
      };
    };
    Description: {
      value: string;
    };
    Title: { value: string };
  };
};
